export default "__VITE_ASSET__D9VM7h1y__"